import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { delftBlue } from "@/theme/colors";
import HandshakeIcon from "@/assets/material-symbols_handshake-outline.svg";
import DocumentIcon from "@/assets/majesticons_document-line.svg";
import CollapsibleSection from "./CollapsibleSection";
import { useSelector } from "react-redux";
import { selectUser } from "@/app/features/auth/authSlice";
import Roles from "@/constants/roles";

const QuickActions = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useSelector(selectUser);

  const handleAddCompany = () => {
    navigate("/companies/add");
  };

  const handleUploadDocument = () => {
    navigate("/documents/add");
  };

  return (
    <CollapsibleSection
      title="Quick Actions"
      defaultExpanded={true}
      showCard={true}
      cardSx={{
        flex: "1 1 0",
        minWidth: { xs: "100%", lg: 0 },
        background: delftBlue[50],
      }}
    >
      <Stack spacing={{ xs: 1.5, sm: 2 }} sx={{ alignSelf: "stretch" }}>
        {user?.role === Roles.SUPER_ADMIN && (
          <Button
            fullWidth
            onClick={handleAddCompany}
            sx={{
              padding: { xs: 1.5, sm: 2 },
              background: "white",
              borderRadius: 1.5,
              outline: `0.8px ${delftBlue[200]} solid`,
              outlineOffset: "-0.8px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 1.5, sm: 2 },
              textTransform: "none",
              "&:hover": {
                background: theme.palette.neutral[50],
              },
            }}
          >
            <Box
              component="img"
              src={HandshakeIcon}
              alt="Add Company"
              sx={{
                width: { xs: 20, sm: 24 },
                height: { xs: 20, sm: 24 },
                objectFit: "contain",
              }}
            />
            <Typography
              sx={{
                textAlign: "center",
                color: delftBlue[950],
                fontSize: { xs: 14, sm: 16 },
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
              }}
            >
              Add Company
            </Typography>
          </Button>
        )}

        <Button
          fullWidth
          onClick={handleUploadDocument}
          sx={{
            padding: { xs: 1.5, sm: 2 },
            background: "white",
            borderRadius: 1.5,
            outline: `0.8px ${delftBlue[200]} solid`,
            outlineOffset: "-0.8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            textTransform: "none",
            "&:hover": {
              background: theme.palette.neutral[50],
            },
          }}
        >
          <Box
            component="img"
            src={DocumentIcon}
            alt="Upload Document"
            sx={{
              width: { xs: 20, sm: 24 },
              height: { xs: 20, sm: 24 },
              objectFit: "contain",
            }}
          />
          <Typography
            sx={{
              textAlign: "center",
              color: delftBlue[950],
              fontSize: { xs: 14, sm: 16 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 500,
            }}
          >
            Upload Document
          </Typography>
        </Button>
      </Stack>
    </CollapsibleSection>
  );
};

export default QuickActions;



